import type { HTMLAttributes } from "react"

type MaterialSymbolProps = HTMLAttributes<HTMLSpanElement> & {
  name: string
}

export const MaterialSymbol = ({ name, className, ...props }: MaterialSymbolProps) => {
  return (
    <span {...props} className={`material-symbols-rounded ${className || ""}`}>
      {name}
    </span>
  )
}
